package pl.decks.personal.components.widgets.responsivegrid

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.ComponentKind
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.addVariantBase
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.vars.animation.TransitionDurationVars
import com.varabyte.kobweb.silk.theme.colors.palette.border
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.AlignItems
import pl.decks.personal.styles.SiteLayout

object ResponsiveGridStylesheet {
    object Vars {
        val gridGap by StyleVariable<CSSLengthOrPercentageNumericValue>(SiteLayout.Space.none)
        val padding by StyleVariable<CSSLengthOrPercentageNumericValue>(SiteLayout.Space.Relative.XSmall)

        val width by StyleVariable<CSSLengthOrPercentageNumericValue>()
        val squishedWidth by StyleVariable<CSSLengthOrPercentageNumericValue>()
        val enlargedWidth by StyleVariable<CSSLengthOrPercentageNumericValue>()

        val borderRadius by StyleVariable<CSSLengthOrPercentageNumericValue>(SiteLayout.Rounding.none)
        val borderWidth by StyleVariable<CSSLengthNumericValue>(SiteLayout.Line.Normal)
        val borderColor by StyleVariable<Color>()
        val focusBorderColor by StyleVariable<Color>()

        val textColor by StyleVariable<Color>()
        val focusColor by StyleVariable<Color>()

        val focusTransitionDuration by StyleVariable(TransitionDurationVars.UltraSlow.value())
    }

    val Grid = CssStyle.base {
        Modifier.gap(Vars.gridGap.value())
    }
    val GridRow = CssStyle.base {
        Modifier.fillMaxWidth().gap(Vars.gridGap.value()).alignItems(AlignItems.Stretch)
    }

    object GridEntry {
        sealed interface Kind : ComponentKind

        val Style = CssStyle.base<Kind> {
            Modifier
                .padding(Vars.padding.value())
                .borderRadius(Vars.borderRadius.value())
                .transition {
                    property("width", "border-color", "color")
                    duration(Vars.focusTransitionDuration.value())
                    timingFunction(TransitionTimingFunction.cubicBezier(0.4, 0.0, 0.2, 1.0))
                }
        }
        val EqualedVariant = Style.addVariantBase {
            Modifier.width(Vars.width.value())
        }
        val EnlargedVariant = Style.addVariantBase {
            Modifier.width(Vars.enlargedWidth.value())
        }
        val SquishedVariant = Style.addVariantBase {
            Modifier.width(Vars.squishedWidth.value())
        }
        val FocusedOutVariant = Style.addVariantBase {
            Modifier
                .color(Vars.textColor.value(colorMode.toPalette().color))
                .border(
                    Vars.borderWidth.value(),
                    LineStyle.Solid,
                    Vars.borderColor.value(colorMode.toPalette().border)
                )
        }
        val FocusedInVariant = Style.addVariantBase {
            Modifier
                .color(Vars.focusColor.value(Vars.textColor.value(colorMode.toPalette().color)))
                .border(
                    Vars.borderWidth.value(),
                    LineStyle.Solid,
                    Vars.focusBorderColor.value(Vars.borderColor.value(colorMode.toPalette().border))
                )
        }
        val Title = CssStyle.base {
            Modifier
                .fillMaxWidth()
                .overflow(Overflow.Hidden)
                .textAlign(TextAlign.Center)
                .whiteSpace(WhiteSpace.NoWrap)
                .textDecorationLine(TextDecorationLine.None)
                .textOverflow(TextOverflow.Ellipsis)
        }
    }
}
